if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.sliderInitialized = false;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.dispatchEvent(new CustomEvent('modal:open', { bubbles: true }));
        setTimeout(() => {
          this.initializeSlider();
          this.showActiveMedia();
        }, 150);
      }

      initializeSlider() {
        if (this.getAttribute('data-slider') !== "true") return;
        if (this.sliderInitialized) return;
        
        const slider = this.querySelector('.product-media-modal-slider');
        if (!slider) return;
        
        if ($(slider).hasClass('slick-initialized')) {
          $(slider).slick('unslick');
        }
        const slickLeft = this.querySelector('div.slick-left');
        const slickRight = this.querySelector('div.slick-right');
        $(slider).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          swipe:false,
          autoplay: false, 
          arrows: true,
          fade: true,
          prevArrow: $(slickLeft),
          nextArrow: $(slickRight),
          adaptiveHeight: true,
          cssEase: 'ease',
          speed: 300,
          lazyLoad: 'ondemand'
        });
        
        this.sliderInitialized = true;
      }

      showActiveMedia() {
        const activeMediaId = this.openedBy.getAttribute('data-media-id');
        if (!activeMediaId) return;
        
        // If slider is initialized, go to the correct slide
        if (this.sliderInitialized) {
          const slider = this.querySelector('.product-media-modal-slider');
          const slides = slider.querySelectorAll('.slide-item');
          
          slides.forEach((slide, index) => {
            if (slide.getAttribute('data-media-id') === activeMediaId) {
              $(slider).slick('slickGoTo', index);
            }
          });
        }
        
        const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
        if (activeMedia) {
          const deferredMedia = activeMedia.querySelector('deferred-media');
          if (deferredMedia) {
            deferredMedia.loadContent();
          }
        }
      }

      refreshSlick() {
        if (this.getAttribute('data-slider') !== "true") return;
        const slider = this.querySelector('.product-media-modal-slider');
        if (slider && $(slider).hasClass('slick-initialized')) {
          $(slider).slick('refresh');
        }
      }
    }
  );
}